import { useCallback } from 'react';
import { exportAndDownloadCSV } from '../../utils/csv-helpers';
import { generateStandardFilename } from '@fortress-technology-solutions/fortress-component-library/utils';

const useCSVExport = ({
  filteredHeaders,
  rows,
  hasAnyFilters,
  selectedRentForecastName,
}) => {
  const onCSVButtonClick = useCallback(() => {
    const fileName = generateStandardFilename({
      type: 'rent-forecast',
      descriptor: selectedRentForecastName,
      extension: 'csv',
    });
    exportAndDownloadCSV({
      excludedHeaders: ['actions'],
      filteredHeaders,
      fileName,
      rows,
      hasAnyFilters,
    });
  }, [filteredHeaders, rows, hasAnyFilters]);

  return {
    onCSVButtonClick,
  };
};

export default useCSVExport;
